import { useSelector } from 'react-redux';
import { Box, Button, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './header.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '../Dashboard.trans.json';
import ToolTip from '@/components/ToolTip/ToolTip';
import useDashboardHeader from './useDashboardHeader';
import ConfirmationModal from './ConfirmationModal';

function DashboardHeader() {
  const { first_name } = useSelector((state) => state.UserSlice.data);
  const { edition } = useSelector((state) => state.DashboardSlice);
  const safetyFirstName = first_name || ' ';
  const {
    didEditionChange,
    showConfirmModal,
    showRefreshButton,
    handleClickRefresh,
    handleCloseConfirmationModal,
    handleConfirmCancel,
    handleConfirmSave,
    handleOpenConfirmationModal,
    toggleEditionMode,
    handleCancel,
    handleSave,
  } = useDashboardHeader();

  return (
    <Box className={styles.dashboardHeader}>
      <Box className={styles.dashboardTitles}>
        <Text className={styles.title}>
          {Trans(translations, 'DashboardTitle.Hello', safetyFirstName)}
        </Text>
        <Text className={styles.subtitle}>
          {Trans(translations, 'DashboardTitle.Subtitle')}
        </Text>
        {edition.active && (
          <Text className={styles.customizing}>
            {Trans(translations, 'Customizing')}
          </Text>
        )}
      </Box>

      {edition.active ? (
        <Box className={styles.buttonsWrapper}>
          <Button
            variant={['subtleText', 'medium']}
            onClick={
              didEditionChange ? handleOpenConfirmationModal : handleCancel
            }
          >
            {Trans(translations, 'Cancel')}
          </Button>
          <Button
            variant={[
              didEditionChange ? 'primary' : 'primaryDisabled',
              'medium',
            ]}
            onClick={handleSave}
          >
            {Trans(translations, 'Save')}
          </Button>
        </Box>
      ) : (
        <Box className={styles.iconsWrapper}>
          {showRefreshButton && (
            <Icon
              className={styles.icon}
              icon="icon-reset"
              onClick={handleClickRefresh}
            />
          )}
          <ToolTip title={Trans(translations, 'CustomizeMyDashboard')}>
            <Icon
              className={styles.icon}
              icon="icon-configuracion"
              onClick={toggleEditionMode}
            />
          </ToolTip>
        </Box>
      )}
      {showConfirmModal && (
        <ConfirmationModal
          handleClose={handleCloseConfirmationModal}
          handleCancel={handleConfirmCancel}
          handleConfirm={handleConfirmSave}
        />
      )}
    </Box>
  );
}

export default DashboardHeader;
